import { ReactNode } from 'react'

import { create } from 'zustand'
import { combine } from 'zustand/middleware'

interface ActionBarButtonsType {
  left: ReactNode[]
  center: ReactNode[]
  right: ReactNode[]
}

const defaultValues: ActionBarButtonsType = {
  left: [],
  center: [],
  right: [],
}

export const useActionBarButtonsStore = create(
  combine(defaultValues, (set) => ({
    resetButtons: (position: 'all' | 'left' | 'center' | 'right' = 'all') => {
      if (position === 'all') set(defaultValues)
      else set({ [position]: [] })
    },
    setLeftButtons: (buttons: ReactNode[]) => set({ left: buttons }),
    setCenterButtons: (buttons: ReactNode[]) => set({ center: buttons }),
    setRightButtons: (buttons: ReactNode[]) => set({ right: buttons }),
  }))
)
